import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from "ui-ember-vite/config/environment";
import compatModules from "@embroider/virtual/compat-modules";
import 'ui-ember-vite/styles/app.css';
import '@fortawesome/fontawesome-free/css/all.css';

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver.withModules(compatModules);
}

loadInitializers(App, config.modulePrefix, compatModules);
